import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { createApi } from 'ReduxHelpers';

type StripeBillingPortalSessionResponse = {
    session?: {
        url?: string;
    };
};

export const stripeBillingPortalApi = createApi('StripeBillingPortal', {
    ...getBackRoyalApiBaseConfig('StripeBillingPortal'),
    endpoints: builder => ({
        createBillingPortalSession: builder.mutation<StripeBillingPortalSessionResponse, void>({
            query: () => ({
                url: 'stripe_billing_portal_sessions',
                method: 'POST',
            }),
        }),
    }),
});
